import type { ToolUIPart, UIMessage } from "ai";

import { ApprovalDetails } from "../ApprovalDetails/ApprovalDetails";

import { useOrganizationApprovalDescription } from "./useOrganizationApprovalDescription";

import { useTranslate } from "@/common/hooks/useTranslate";
import type { ApprovalContent } from "@/features/Assistant/contexts/AssistantConfigContext";

export const useOrganizationApprovalContent = (part: ToolUIPart, messages: UIMessage[]): ApprovalContent => {
  const { t } = useTranslate();
  const description = useOrganizationApprovalDescription(part, messages);
  const details = <ApprovalDetails description={description} />;

  switch (description.kind) {
    case "handoff":
      return {
        description: t("dashboard", "organizationAssistant.approval.handoff"),
        details,
        noteLabel: t("dashboard", "assistant.approval.requestHumanSupportNote"),
      };
    case "resend":
      return {
        description: t("dashboard", "organizationAssistant.approval.resend"),
        details,
        canApprove: Boolean(description.card),
      };
    case "sales":
      return {
        description:
          description.card.effect === "reopen"
            ? t("dashboard", "organizationAssistant.approval.salesReopen")
            : t("dashboard", "organizationAssistant.approval.salesClose"),
        details,
        canApprove: Boolean(description.card.formName),
      };
    case "unknown":
      return { description: t("dashboard", "assistant.approval.defaultDescription") };
  }
};
